const styles = theme => ({
    background:{
        backgroundColor: "#fbfaff",
        paddingBottom: '200px',
    },
    content_container:{
        paddingLeft: "6%",
        paddingRight: "6%"
    },
    top_section_text: {
        display: "flex",
        alignItems: "center", 
        justifyContent: "space-between", 
    },
    no_idea_img: {
        height: '210px',
        width: '288px',
        marginBottom: '20px',
    },
    no_idea_title: {
        textAlign: 'center',
        fontSize: '32px',
        color: '#333333',
        fontFamily: 'VodafoneRg-Regular'
    },
    title: {
        fontFamily: 'VodafoneRg-Regular',
        fontSize: "32px",
        color: "#333333",
    },
    invested_ideas_number: {
        fontFamily: 'VodafoneRg-Regular',
        fontSize: "20px",
        paddingTop: "16px",
        cursor: 'pointer',
        color: "#7836FF",
    },
    lower_title: {
        fontFamily: "VodafoneRg-Regular",
        color: "#333333",
        fontSize: "40px",
        textAlign: "center",
        marginBottom: "16px",
    },
    lower_description: {
        fontFamily: "VodafoneLt-Regular",
        color: "#333333",
        fontSize: "24px",
        textAlign: "center",
        marginTop: "16px",
    },
    idea_grid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        alignItems: "center",
        justifyItems: "center",
        '@media (max-width:1250px)': { 
            gridTemplateColumns: "repeat(3, 1fr)",
        },
        '@media (max-width:1050px)': { 
            gridTemplateColumns: "repeat(2, 1fr)",
        },
        '@media (max-width:720px)': { 
            gridTemplateColumns: "1fr",
        },
    }
  })
  

export default styles
